import styled from 'styled-components';

const FullViewportHeight = styled.div`
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
`;

export default FullViewportHeight;
